import TYPES from '@/modules/shared/types';

// Domain
import {
  EmergencyFundAvailabilityRepository,
} from '@/modules/flagship/catalogs/emergency-fund-availability/domain/repositories/emergency-fund-availability-repository';
import {
  EmergencyFundAvailabilityEntity,
} from '@/modules/flagship/catalogs/emergency-fund-availability/domain/entities/emergency-fund-availability-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class EmergencyFundAvailabilityHttpRepository implements
  EmergencyFundAvailabilityRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/catalogs/emergency-fund-availability/`;

  execute(): Promise<Array<EmergencyFundAvailabilityEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
